import * as React from 'react';
export var gameContext = React.createContext(null);
export var GameProvider = gameContext.Provider;
//# sourceMappingURL=GameProvider.js.map